import React from 'react'
import PropTypes from 'prop-types'
import { Divider, makeStyles } from '@material-ui/core'
import FlexRow from '../../../../components/molecules/FlexRow'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import MessageAttachments from './MessageAttachments'
import MessageButtons from './MessageButtons'

const useStyles = makeStyles(() => ({
  footer: {
    marginTop: 'var(--margin-sm)',
    paddingTop: 'var(--padding-sm)'
  },
  actionsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingTop: 'var(--padding-xs)',
    paddingBottom: 'var(--padding-xs)'
  },
  attachmentsContainer: {
    flex: 1,
    '& .mt-3': {
      marginTop: 0
    }
  }
}))

function MessageFooter ({ message, onRetry, isRetrying, parentInfo }) {
  const classes = useStyles()

  return (
    <FlexColumn className={classes.footer}>
      <Divider />
      <FlexRow className={classes.actionsRow}>
        <div className={classes.attachmentsContainer}>
          <MessageAttachments message={message} />
        </div>
      </FlexRow>
      <MessageButtons
        message={message}
        onRetry={onRetry}
        isRetrying={isRetrying}
        parentInfo={parentInfo}
      />
    </FlexColumn>
  )
}

MessageFooter.propTypes = {
  message: PropTypes.shape({
    threadMessageId: PropTypes.string,
    isPlaceholder: PropTypes.bool,
    actor: PropTypes.string,
    isGenerating: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    generationStatus: PropTypes.string,
    createdDate: PropTypes.string,
    message: PropTypes.string,
    data: PropTypes.object,
    feedback: PropTypes.shape({
      type: PropTypes.oneOf(['thumbs_up', 'thumbs_down'])
    })
  }).isRequired,
  onRetry: PropTypes.func,
  isRetrying: PropTypes.bool,
  parentInfo: PropTypes.shape({
    parentId: PropTypes.string,
    parentType: PropTypes.oneOf(['schedule', 'thread'])
  })
}

export default MessageFooter
